import React, { useState, useEffect, useMemo } from "react";
import { updateBookingStatus } from "../../ducks/actions";
// others
import { Loading } from "./index";
import { FormProvider, useForm, useWatch } from "react-hook-form";
import Button from "../../../../molecules/Button";
import { useDispatch, useSelector } from "react-redux";
import { PopupConfirm } from "../../../../atoms/Popup";
import { useParams, useNavigate } from "react-router-dom";
import { Col, Row, Form, Radio, Space, message } from "antd";
import { createRenewal, updateBooking, getBookingDetail, RefreshRenwalData } from "../../ducks/actions";
import { syncWithOracelOnUpdate } from "../../ducks/services";
import { InputField, InputRadio, ReactSelectField } from "../../../../atoms/FormElement";
import { InputNumberFieldV2 as InputNumberField } from "../../../../atoms/FormElement/InputNumberField";
import { options, apiDateFormat, changeValueOptions, renewFor, getValidInstallments } from "../utils";
import { currencyFormat } from "../../../../../utils/media";
import { SecurityDepositTopUp } from "./security-deposit-top-up";
import { getMinErrorMessage } from "../../../../libs/form/utils/getMinErrorMessage";
import { getInputPlaceholderMessage } from "../../../../libs/form";
import { DecimalUtils } from "../../../../libs/utils";

interface IProps {
  parentState: (obj: object) => void;
  onModalClose?: any;
  renewalFormConform?: Boolean;
}

let initialState = {
  visible: false,
  changeValue: "",
};

const index = (props: IProps) => {
  // redux states
  const { bookingDetails } = useSelector((state: any) => state.newBooking);
  const { bookingTerms } = bookingDetails;
  let initialUpdateRentAmount = bookingTerms?.renewalAmount
    ? bookingTerms?.renewalAmount
    : bookingTerms?.annualBaseRent;
  // hooks initialization
  const navigate: any = useNavigate();
  const dispatch: any = useDispatch();
  const { leaseId = "" } = useParams();
  const typeOfRenewal = useParams();
  const [updatedContractRent, setUpdatedContractRent] = useState(0);
  const [renewForValue, setRenewFor] = useState(12);
  const [durationType, setDurationType] = useState<"months" | "days">("months");

  let newRenewalType = typeOfRenewal["*"];
  const form = useForm();
  const {
    control,
    setValue,
    getValues,
    handleSubmit,
    formState: { errors },
  } = form;

  const isFormDisabled = Boolean(bookingDetails?.disableConfirmRenewalForm && props?.renewalFormConform);

  // states
  const [{ visible, changeValue }, setState] = useState(initialState);

  const updateState = (state: {}) => setState((prevState: any) => ({ ...prevState, ...state }));

  useEffect(() => {
    const initialDurationType = bookingTerms?.durationType || "months";
    setDurationType(initialDurationType);
    setValue("durationType", initialDurationType);
    setValue(
      "numberOfInstallments",
      initialDurationType === "days"
        ? { label: 1, value: 1 }
        : {
            label: bookingTerms?.numberOfInstallments,
            value: bookingTerms?.numberOfInstallments,
          },
    );
    updateState({ changeValue: bookingTerms?.changeValue });
    bookingTerms?.renewalAmount && updateContractRent(bookingTerms?.renewalAmount, 1, null, initialDurationType);
  }, []);

  const changeValueField = getValues("changeValue");

  const handleAmount = (value: any) => {
    let updatedRent: any = "";
    const numValue =
      typeof value === "object" && value?.target?.value ? parseFloat(value.target.value) : parseFloat(value || 0);
    const amountType = getValues("amountType");
    const changeValue = getValues("changeValue");
    const annualBaseRent = getValues("annualBaseRent");

    if (changeValue === "increase" && amountType === "amount") updatedRent = annualBaseRent + numValue;
    else if (changeValue === "decrease" && amountType === "amount") updatedRent = annualBaseRent - numValue;
    else if (changeValue === "increase" && amountType === "percentage")
      updatedRent = annualBaseRent + (annualBaseRent * numValue) / 100;
    else if (changeValue === "decrease" && amountType === "percentage")
      updatedRent = annualBaseRent - (annualBaseRent * numValue) / 100;

    if (!numValue) updatedRent = numValue;

    setValue("renewalAmount", updatedRent > 0 ? Number(updatedRent) : "");
    updateContractRent(renewForValue);
  };

  // according to story 13377 sprint 58

  const buttonLabel = () => {
    if (
      bookingTerms?.changeValue &&
      bookingDetails?.renewalApproval === "enable" &&
      (bookingDetails?.renewalStatus === "ready_to_send" || bookingDetails?.renewalStatus === "sent")
    ) {
      return "Send for Approval";
    } else {
      return "Update";
    }
  };
  //  according to story-10079 in sprint 40
  const onStatusBookingForm = async () => {
    //  after discussion with ajay stoping it for his support
    if (bookingDetails?.renewalApproval === "enable") {
      let body: any = {};
      body["renewalSendForApproval"] = "yes";
      try {
        await dispatch(updateBookingStatus({ leaseId, body }));
        // message.success("Successfully updated");
      } catch (error) {
        message.error("failed to updated");
      }
    }
  };

  const submitCommonLogic = async (payLoad, dataCopy) => {
    const { securityDepositTopUp, ...restBookingTerms } = bookingTerms;

    try {
      updateState({ visible: true });
      const response = await dispatch(
        !bookingDetails?.bookingTerms?.changeValue
          ? createRenewal({
              leaseId,
              body: payLoad,
            })
          : newRenewalType === "renewalTorenewal" && bookingDetails?.bookingTerms?.changeValue
            ? createRenewal({
                leaseId,
                body: payLoad,
              })
            : await updateBooking({
                leaseId,
                body: {
                  bookingTerms: { ...restBookingTerms, ...dataCopy },
                },
              }),
      );
      //  according to story-10079 in sprint 40
      if (response?.status === 200 && bookingDetails?.bookingTerms?.changeValue) {
        if (bookingDetails?.renewalStatus === "ready_to_send" || bookingDetails?.renewalStatus === "sent") {
          buttonLabel() === "Send for Approval" && onStatusBookingForm();
        }
      }

      if (!bookingDetails?.bookingTerms?.changeValue) {
        navigate(`/viewbookingform/${response?.data?.result?.leaseId}`, {
          state: { renewal: true },
        });
      } else if (newRenewalType === "renewalTorenewal" && bookingDetails?.bookingTerms?.changeValue) {
        navigate(`/viewbookingform/${response?.data?.result?.leaseId}`, {
          state: { renewal: true },
        });
      } else {
        navigate(`/viewbookingform/${leaseId}`, {
          state: { renewal: true },
        });
      }

      if (bookingDetails?.isAgp?.toLowerCase() === "yes") {
        let result = await syncWithOracelOnUpdate(leaseId);
        if (result) {
          dispatch(RefreshRenwalData());
        }
      } else {
        await dispatch(getBookingDetail(response?.data?.result?.leaseId));
      }

      message.success(response?.data.message);

      updateState({ visible: false });
      props.parentState({
        modalPayload: { iKey: "", title: "", extraText: "", open: false },
      });
    } catch (error) {
      updateState({ visible: false });
      props.parentState({ visible: false });
      message.error(error.response?.data?.error || error.response?.data?.message);
    }
  };

  const onSubmit = async (data: any) => {
    let { isTopUpRequired, securityDepositTopUp, renewFor, renewalTerm, ...dataCopy } = data;
    const { securityDepositTopUp: _securityDepositTopUp, ...restBookingTerms } = bookingTerms;

    dataCopy = {
      ...dataCopy,
      ...{ numberOfInstallments: dataCopy["numberOfInstallments"].value },
      ...{ numberOfRenewalTerms: renewFor?.value },
      ...{ renewalTerm: parseInt(renewalTerm) },
      ...(isTopUpRequired ? { securityDepositTopUp } : {}),
    };

    const isExtension = data?.durationType === "days" || (data?.durationType === "months" && renewFor?.value < 12);

    for (let key in dataCopy) {
      if (!["amountType", "changeValue", "securityDepositTopUp", "durationType"].includes(key)) {
        dataCopy[key] = DecimalUtils.toNumber(dataCopy[key]);
      }
      if (key === "changeValue" && dataCopy[key] === "no_change") {
        dataCopy["amountType"] = "";
      }
    }

    if (isExtension && dataCopy?.contractAmount != null) {
      dataCopy["contractRent"] = dataCopy["contractAmount"];
      delete dataCopy["contractAmount"];
    }

    try {
      let payLoad = {
        email: bookingDetails.tenantDetails.email,
        name: bookingDetails.tenantDetails.tenantNameEN,
        mobile: bookingDetails.tenantDetails.mobileNumber,
        unitCode: bookingDetails.propertyDetails.unitCode,
        arabicName: bookingDetails.tenantDetails.tenantNameAR,
        bookingTerms: {
          ...restBookingTerms,
          ...dataCopy,
          billingCharges: [],
        },

        leaseTerms: {
          ...bookingDetails.leaseTerms,
          ...{
            leaseStartDate: apiDateFormat(bookingDetails?.leaseTerms?.leaseStartDate),
            leaseEndDate: apiDateFormat(bookingDetails?.leaseTerms?.leaseEndDate),
          },
        },
      };

      if (!props?.renewalFormConform) {
        if (buttonLabel() != "Update") {
          PopupConfirm({
            title: `Are You Sure?`,
            onOk: async () => {
              await submitCommonLogic(payLoad, dataCopy);
            },
            okText: "Yes",
          });
        } else {
          await submitCommonLogic(payLoad, dataCopy);
        }
      } else {
        //  for story 8455 Upcoming Renewals > Add buttons for Confirm Renewal and Confirm Move-out
        PopupConfirm({
          title: `This will set the tenant's renewal decision to Renewal Accepted. Are you sure you wish to proceed?`,
          onOk: async () => {
            updateState({ visible: true });
            let payload: any = { ...restBookingTerms, ...dataCopy };

            try {
              const response = await dispatch(
                updateBooking({
                  leaseId,
                  body: {
                    onlyBooking: true,
                    renewalToTenant: "renewal_accepted",
                    bookingTerms: payload,
                  },
                }),
              );

              if (!bookingDetails?.bookingTerms?.changeValue)
                navigate(`/viewbookingform/${response?.data?.result?.leaseId}`, {
                  state: { renewal: true },
                });

              if (bookingDetails?.isAgp?.toLowerCase() === "yes") {
                let result = await syncWithOracelOnUpdate(leaseId);
                if (result) {
                  dispatch(RefreshRenwalData());
                }
              } else {
                await dispatch(getBookingDetail(response?.data?.result?.leaseId));
              }

              message.success(response?.data.message);
              updateState({ visible: false });
              props.parentState({
                modalPayload: {
                  iKey: "",
                  title: "",
                  extraText: "",
                  open: false,
                },
              });
            } catch (eror) {
              updateState({ visible: false });
              props.parentState({ visible: false });
              message.error(eror.response?.data?.error || eror.response?.data?.message);
            }
          },
          okText: "Yes",
        });
      }
    } catch (error) {
      console.log(error, "Upcoming");
      updateState({ visible: false });
      props.parentState({ visible: false });
      message.error(error.response?.data?.error || error.response?.data?.message);
    }
  };

  // Watch all form values
  const watchedValues = useWatch({
    control,
  });

  useEffect(() => {}, [watchedValues]);

  const renewForDays = Array.from({ length: 30 }, (_, index) => ({
    label: `${index + 1} day${index === 0 ? "" : "s"}`,
    value: index + 1,
  }));
  const formatRenewForLabel = (value: number, type: "months" | "days") =>
    `${value} ${type === "days" ? (value === 1 ? "day" : "days") : "month"}`;

  const updateContractRent = (data, type = null, changeTypeParam = null, durationTypeParam = null) => {
    // formula Updated Annual rent / 12 * Number of months or / 365 * Number of days
    let renewalAmount = type === 1 ? data : getValues("renewalAmount");
    let annualBaseRent = type === 1 ? data : getValues("annualBaseRent");
    const selectedDurationType = durationTypeParam || durationType;
    const selectedRenewFor = getValues("renewFor");
    let updateRenewFor =
      data?.value ||
      selectedRenewFor?.value ||
      renewForValue ||
      bookingTerms?.numberOfRenewalTerms ||
      (selectedDurationType === "days" ? 1 : 12);
    data?.value && setValue("numberOfInstallments", { label: "1", value: 1 });

    if (changeTypeParam === "no_change") {
      if (selectedRenewFor?.value) {
        setValue("renewFor", {
          label: formatRenewForLabel(selectedRenewFor?.value, selectedDurationType),
          value: selectedRenewFor?.value,
        });
        updateRenewFor = selectedRenewFor?.value;
      } else if (bookingTerms?.numberOfRenewalTerms) {
        setValue("renewFor", {
          label: formatRenewForLabel(bookingTerms?.numberOfRenewalTerms, selectedDurationType),
          value: bookingTerms?.numberOfRenewalTerms,
        });
        updateRenewFor = bookingTerms?.numberOfRenewalTerms;
      }
    } else if (changeValueField === "no_change" && changeTypeParam) {
      updateRenewFor = selectedRenewFor?.value || renewForValue || (selectedDurationType === "days" ? 1 : 12);
    }

    const getUpdatedRenewalAmount = renewalAmount ? renewalAmount : annualBaseRent;
    setRenewFor(updateRenewFor);
    const divisor = selectedDurationType === "days" ? 365 : 12;
    let formattedRentAmount = (getUpdatedRenewalAmount / divisor) * updateRenewFor;
    const updateRentAmount = formattedRentAmount > 0 ? DecimalUtils.toNumber(formattedRentAmount) : 0;

    setUpdatedContractRent(updateRentAmount);

    if (bookingDetails?.renewalApproval === "enable" && changeTypeParam === "no_change") {
      setValue("contractAmount", bookingTerms?.annualBaseRent);
      setValue("renewalAmount", bookingTerms?.annualBaseRent);
    } else {
      setValue(
        "contractAmount",
        changeTypeParam !== "no_change"
          ? updateRentAmount
          : (bookingTerms?.renewalAmount ?? bookingTerms?.annualBaseRent),
      );
      // setValue("amountChange", bookingTerms?.amountChange);
    }
    // changeTypeParam !== "no_change"
    //   ? setValue("contractAmount", updateRentAmount)
    //   : setValue("contractAmount", bookingTerms?.renewalAmount ?? bookingTerms?.annualBaseRent);
  };
  //  set initial value of renewal terms For
  const setRenewForinitialTerms = () => {
    const selectedDurationType = bookingTerms?.durationType || durationType;
    const renewForOptions = selectedDurationType === "days" ? renewForDays : renewFor;
    if (bookingTerms?.numberOfRenewalTerms) {
      return {
        label: formatRenewForLabel(bookingTerms?.numberOfRenewalTerms, selectedDurationType),
        value: bookingTerms?.numberOfRenewalTerms,
      };
    } else {
      return renewForOptions[renewForOptions?.length - 1];
    }
  };

  const setHelpingTextForApproveRent = (type) => {
    let diff = null;
    let updateAnnaulRent = watchedValues?.renewalAmount ? watchedValues?.renewalAmount : initialUpdateRentAmount;
    if (type === 1) {
      return bookingDetails?.approvedAnnualRent
        ? `Approved Annual Rent ${currencyFormat(bookingDetails?.approvedAnnualRent)}`
        : `Approved annual rent not available`;
    } else {
      if (bookingDetails?.approvedAnnualRent && bookingDetails?.approvedAnnualRent < updateAnnaulRent) {
        diff = updateAnnaulRent - bookingDetails?.approvedAnnualRent;
        return `${currencyFormat(diff)} above approved rent`;
      } else if (bookingDetails?.approvedAnnualRent && bookingDetails?.approvedAnnualRent > updateAnnaulRent) {
        diff = updateAnnaulRent - bookingDetails?.approvedAnnualRent;
        return ` ${currencyFormat(diff)} below approved rent`;
      }
    }
  };

  const watchedRenewFor = getValues("renewFor");

  const isExtension = useMemo(() => {
    return durationType === "days" || (durationType === "months" && watchedRenewFor?.value < 12);
  }, [durationType, watchedRenewFor]);

  const renewForOptions = durationType === "days" ? renewForDays : renewFor;

  return (
    <FormProvider {...form}>
      <Form
        layout="vertical"
        name="bookingform"
        scrollToFirstError
        className="bf-main"
        onFinish={handleSubmit(onSubmit)}
      >
        <Loading visible={visible} />

        <Col flex={1}>
          <InputField
            disabled={true}
            control={control}
            fieldname="renewalTerm"
            label="Renewal Term"
            initValue={"12 months"}
          />
        </Col>
        <Col flex={1}>
          <Space direction="vertical" style={{ width: "100%" }}>
            <InputRadio
              formItemStyle={{ marginBottom: 0 }}
              control={control}
              fieldname="durationType"
              label="Renew For"
              initValue={bookingTerms?.durationType || "months"}
              disabled={isFormDisabled || bookingDetails?.isAgp?.toLowerCase() === "yes"}
              options={
                <Row gutter={[16, 16]}>
                  {[
                    { label: "Months", value: "months" },
                    { label: "Days", value: "days" },
                  ].map((option, i) => (
                    <Col span={8} key={`${option.value}-${i}`}>
                      <Radio value={option.value}>{option.label}</Radio>
                    </Col>
                  ))}
                </Row>
              }
              onChange={(e: any) => {
                const nextDurationType = e.target.value;
                setDurationType(nextDurationType);
                setValue("durationType", nextDurationType);
                if (nextDurationType === "days") {
                  const firstDay = renewForDays[0];
                  setValue("renewFor", firstDay);
                  setValue("numberOfInstallments", { label: "1", value: 1 });
                  updateContractRent(firstDay, null, null, nextDurationType);
                } else {
                  const defaultMonth = renewFor[renewFor.length - 1];
                  setValue("renewFor", defaultMonth);
                  updateContractRent(defaultMonth, null, null, nextDurationType);
                }
              }}
            />
            <ReactSelectField
              control={control}
              fieldname="renewFor"
              selectOption={renewForOptions}
              initValue={setRenewForinitialTerms()}
              onChange={(option) => updateContractRent(option)}
              helpingText="Specify the duration in months or days for the new contract"
              iProps={{
                placeholder: "Select one",
                isDisabled: isFormDisabled || bookingDetails?.isAgp?.toLowerCase() === "yes",
              }}
            />
          </Space>
        </Col>
        <Col flex={1}>
          <InputNumberField
            disabled={true}
            isRequired={true}
            control={control}
            format="currency"
            fieldname="annualBaseRent"
            defaultValue={bookingTerms?.annualBaseRent}
            label="Current Annual Rent"
            formItemProps={{ extra: setHelpingTextForApproveRent(1) }}
          />
        </Col>
        <Col flex={1}>
          <ReactSelectField
            control={control}
            isRequired={true}
            label="No. of instalment"
            fieldname="numberOfInstallments"
            selectOption={
              durationType === "days"
                ? [{ label: "1", value: 1 }]
                : getValidInstallments(renewForValue ? renewForValue : 12)
            }
              iProps={{
                placeholder: "Select one",
                isDisabled: isFormDisabled || (bookingDetails?.isAgp?.toLowerCase() === "yes" ? true : durationType === "days"),
              }}
            validate={errors.numberOfInstallments && "error"}
            rules={{ required: "Please select no. of installments" }}
            validMessage={errors.numberOfInstallments && errors.numberOfInstallments.message}
          />
        </Col>

        <Col flex={1}>
          <InputRadio
            disabled={isFormDisabled || bookingDetails?.isAgp?.toLowerCase() === "yes"}
            isRequired={true}
            control={control}
            fieldname="changeValue"
            initValue={newRenewalType && bookingDetails?.leaseType !== "extension" ? "" : bookingTerms?.changeValue}
            label="Increase or decrease your rent?"
            validate={errors.changeValue && "error"}
            validMessage={errors.changeValue && errors.changeValue.message}
            rules={{ required: "This field is required" }}
            onChange={(e: any) => {
              updateState({ changeValue: e.target.value });
              setValue("amountChange", "");
              if (e.target.value) {
                if (bookingTerms?.renewalAmount && !bookingTerms?.contractRent) {
                  setValue("renewalAmount", bookingTerms?.renewalAmount);
                  setValue("contractAmount", bookingTerms?.renewalAmount);
                  updateContractRent(bookingTerms?.renewalAmount, 1, e.target.value);
                } else if (bookingTerms?.renewalAmount && bookingTerms?.contractRent) {
                  setValue("renewalAmount", bookingTerms?.renewalAmount);
                  setValue("contractAmount", bookingTerms?.contractRent);
                } else {
                  setValue("renewalAmount", bookingTerms?.annualBaseRent);
                  setValue("contractAmount", bookingTerms?.annualBaseRent);
                  updateContractRent(bookingTerms?.annualBaseRent, 1, e.target.value);
                }
              }
            }}
            options={
              <Row gutter={[16, 16]}>
                {changeValueOptions.map((option, i) => (
                  <Col span={8} key={`${option.value}-${i}`}>
                    <Radio value={option.value}>{option.label}</Radio>
                  </Col>
                ))}
              </Row>
            }
          />
        </Col>

        {changeValue && changeValue !== "no_change" && (
          <>
            <Col flex={1}>
              <InputRadio
                disabled={isFormDisabled || bookingDetails?.isAgp?.toLowerCase() === "yes"}
                isRequired={true}
                control={control}
                fieldname="amountType"
                label="Type of Adjustment"
                initValue={
                  newRenewalType && bookingDetails?.leaseType !== "extension"
                    ? ""
                    : bookingTerms?.amountType || "amount"
                }
                validate={errors.amountType && "error"}
                validMessage={errors.amountType && errors.amountType.message}
                rules={{
                  required: "This field is required",
                }}
                onChange={() => {
                  setValue("amountChange", "");
                  setValue("renewalAmount", "");
                }}
                options={
                  <Row gutter={[16, 16]}>
                    {options.map((option, i) => (
                      <Col span={8} key={`${option.value}-${i}`}>
                        <Radio value={option.value}>{option.label}</Radio>
                      </Col>
                    ))}
                  </Row>
                }
              />
            </Col>
            <Col flex={1}>
              <InputNumberField
                isRequired={true}
                fieldname={"amountChange"}
                label="Amount of Adjustment"
                format="currency"
                control={control}
                disabled={isFormDisabled || bookingDetails?.isAgp?.toLowerCase() === "yes"}
                onChange={(e) => handleAmount(e)}
                defaultValue={
                  newRenewalType && bookingDetails?.leaseType !== "extension" ? "" : bookingTerms?.amountChange
                }
                rules={{
                  validate: (value) => {
                    const numericValue = Number(value);

                    if (!numericValue || numericValue < 1) return getMinErrorMessage(null, "greater", 0);

                    return true;
                  },
                }}
                inputNumberProps={{ placeholder: getInputPlaceholderMessage("Amount of Adjustment") }}
              />
            </Col>
          </>
        )}

        {changeValue && (
          <>
            <Col flex={1}>
              <InputNumberField
                disabled={true}
                isRequired={true}
                control={control}
                format="currency"
                fieldname="renewalAmount"
                defaultValue={
                  newRenewalType && bookingDetails?.leaseType !== "extension" ? "0" : bookingTerms?.renewalAmount
                }
                label={changeValue === "no_change" ? "Annual Rent Amount" : "Updated Annual Rent"}
                inputNumberProps={{}}
                formItemProps={{ extra: setHelpingTextForApproveRent(2) }}
              />
            </Col>

            <Col flex={1}>
              <InputNumberField
                isRequired={true}
                fieldname={"contractAmount"}
                label="Updated Contract Rent"
                format="currency"
                control={control}
                disabled={isFormDisabled || !isExtension}
                defaultValue={
                  updatedContractRent > 0
                    ? DecimalUtils.toNumber(updatedContractRent)
                    : DecimalUtils.toNumber(bookingTerms?.renewalAmount)
                }
                rules={{
                  validate: (value) => {
                    const numericValue = Number(value);

                    if (!numericValue || numericValue < 1) return getMinErrorMessage(null, "greater", 0);

                    return true;
                  },
                }}
                inputNumberProps={{ placeholder: getInputPlaceholderMessage("Updated Contract Rent") }}
              />
            </Col>
          </>
        )}

        <SecurityDepositTopUp disabled={isFormDisabled} />

        <Row gutter={24} className="footer">
          <Space size="middle">
            <Button label="Cancel" className="bf-discard-button" onClick={() => props.onModalClose()} />

            {props?.renewalFormConform ? (
              <Button type="submit" className="cc-fotter_next-button" label={"Confirm"} />
            ) : (
              <Button
                type="submit"
                className="cc-fotter_next-button"
                label={bookingTerms?.changeValue ? buttonLabel() : "Create"}
              />
            )}
          </Space>
        </Row>
      </Form>
    </FormProvider>
  );
};

export default index;
